define(function (require) {
    var $ = require("jquery");
    var ko = require("knockout");
    // var moment = require("moment");
    require("bootstrapDatePicker");

    ko.bindingHandlers.uniqueId = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor();
            var idMod = "id-" + (allBindingsAccessor().uniqueMod || 0);
            value[idMod] = value[idMod] || ko.bindingHandlers.uniqueId.prefix + ++ko.bindingHandlers.uniqueId.counter;

            element.id = value[idMod];
        },
        counter: 0,
        prefix: "unique"
    };

    ko.bindingHandlers.uniqueFor = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor();
            var idMod = "id-" + (allBindingsAccessor().uniqueMod || 0);
            value[idMod] = value[idMod] || ko.bindingHandlers.uniqueId.prefix + ++ko.bindingHandlers.uniqueId.counter;

            element.setAttribute("for", value[idMod]);
        }
    };

    ko.bindingHandlers.enterKey = {
        init: function (element, valueAccessor, allBindings, viewModel) {
            var callback = valueAccessor();
            $(element).keypress(function (event) {
                var keyCode = event.which ? event.which : event.keyCode;
                if (keyCode === 13) {
                    callback.call(viewModel);
                    return false;
                }
                return true;
            });
        }
    };

    ko.bindingHandlers.bootstrapAccordion = {
        // copied from http://jsfiddle.net/pkvn79h8/22/
        init: function (elem, value, allBindings, viewModel, bindingContext) {
            var options = ko.utils.unwrapObservable(value()),
                itemId = ko.utils.unwrapObservable(options.item) || "accordion-group";

            function toggle(shouldMoveFocus) {
                var isOpen = !$('[aria-controls="' + itemId + '"]').hasClass("collapsed");

                $("#" + itemId).collapse("toggle");
                $('[aria-controls="' + itemId + '"]')
                    .toggleClass("collapsed")
                    .attr("aria-expanded", isOpen);

                if (shouldMoveFocus && $('[aria-controls="' + itemId + '"]').length > 1) {
                    if (isOpen) {
                        $('[aria-controls="' + itemId + '"]:visible').focus();
                    } else {
                        $("#" + itemId)
                            .find("select, input, textarea, button, a")
                            .eq(0)
                            .focus();
                    }
                }
            }

            $(elem)
                .on("mousedown", function (ev) {
                    ev.preventDefault();
                    toggle();
                })
                .on("keyup", function (ev) {
                    ev.preventDefault();
                    if (ev.which === 13) {
                        toggle(true);
                    } else {
                        log(ev.which);
                    }
                });
        }
    };

    ko.bindingHandlers.tooltip = {
        init: function (element, valueAccessor) {
            var local = ko.utils.unwrapObservable(valueAccessor()),
                options = {};

            ko.utils.extend(options, ko.bindingHandlers.tooltip.options);
            ko.utils.extend(options, local);

            $(element).tooltip(options);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).tooltip("dispose");
            });
        },
        options: {
            placement: "top",
            trigger: "hover focus"
        }
    };

    ko.bindingHandlers.datepicker = {
        init: function (element, valueAccessor, allBindingsAccessor) {
            var options = allBindingsAccessor().datepickerOptions || {};
            $(element)
                .datepicker(options)
                .on("changeDate", function (ev) {
                    var observable = valueAccessor();
                    return observable(ev.date.toLocaleDateString("en-US"));
                });
        },
        update: function (element, valueAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor());
            $(element).datepicker("setValue", value);
        }
    };
});
